export { default as default } from './ItemNoticia';
